// Shared CSV contract for roster import — used by the standalone import page and
// the Advanced create/edit Import Roster modal so the 12-column requirement and
// the template stay in one place.

import { pendoTrackEventWithProperties } from "utils/pendo/pendoHelpers";
import { LeaguesV2Events } from "../analytics/leaguesV2Events";

export const ROSTER_CSV_COLUMNS = [
  "username",
  "first_name",
  "last_name",
  "email",
  "country_code",
  "phone_number",
  "zip_code",
  "date_of_birth",
  "gender",
  "handedness",
  "handicap",
  "tee",
] as const;

const SAMPLE_CSV = [
  ROSTER_CSV_COLUMNS.join(","),
  "jsmith,John,Smith,john.smith@example.com,1,5551234567,12345,1985-06-15,M,R,12.4,white",
  "mjones,Mary,Jones,mary.jones@example.com,1,5559876543,90210,1990-03-22,F,R,18.0,red",
].join("\n");

/** Download the 12-column CSV template (header + two example rows). */
export function downloadRosterTemplate() {
  pendoTrackEventWithProperties(LeaguesV2Events.DOWNLOAD_ROSTER_TEMPLATE, {});
  const blob = new Blob([SAMPLE_CSV], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "roster_import_template.csv";
  a.click();
  URL.revokeObjectURL(url);
}

/** Count data rows in a CSV (non-empty lines minus the header) for a quick
 *  "N rows" hint on the selected file. Returns null if the file can't be read. */
export async function countCsvDataRows(file: File): Promise<number | null> {
  try {
    const text = await file.text();
    const lines = text.split(/\r?\n/).filter((l) => l.trim().length > 0);
    return Math.max(0, lines.length - 1);
  } catch {
    return null;
  }
}
